import { Event } from "Global/Base/Events";
import { IDisposable } from "Global/Base/IDisposable";
import { EventsController } from "Global/Dom/EventsController";
import { IKeyboardModifiers, IKeyboardModifiersWatcher } from "./IKeyboardModifiersWatcher";

export class KeyboardModifiersWatcher implements IKeyboardModifiersWatcher, IDisposable {
    private _eventsController: EventsController;
    private _modifiers: IKeyboardModifiers;

    private _altChanged: Event<KeyboardModifiersWatcher, boolean> = new Event<KeyboardModifiersWatcher, boolean>();

    private _ctrlChanged: Event<KeyboardModifiersWatcher, boolean> = new Event<KeyboardModifiersWatcher, boolean>();

    private _shiftChanged: Event<KeyboardModifiersWatcher, boolean> = new Event<KeyboardModifiersWatcher, boolean>();
    private _modifiersChanged: Event<KeyboardModifiersWatcher, IKeyboardModifiers> = new Event<KeyboardModifiersWatcher, IKeyboardModifiers>();
    private _mouseMoveListener: (mouseEvent: MouseEvent) => void;

    public get altChanged(): Event<KeyboardModifiersWatcher, boolean> {
        return this._altChanged;
    }

    public get ctrlChanged(): Event<KeyboardModifiersWatcher, boolean> {
        return this._ctrlChanged;
    }

    public get shiftChanged(): Event<KeyboardModifiersWatcher, boolean> {
        return this._shiftChanged;
    }
    public get modifiersChanged(): Event<KeyboardModifiersWatcher, IKeyboardModifiers> {
        return this._modifiersChanged;
    }

    constructor() {
        this._modifiers = {
            alt: false,
            ctrl: false,
            shift: false,
        };

        this._eventsController = new EventsController();

        this._eventsController.addListener(document, "keydown", this._updateModifiers.bind(this));
        this._eventsController.addListener(document, "keyup", this._updateModifiers.bind(this));

        // Pro prvotní získání informací o modifikátorech klávesnice ve chvíli, kdy ještě nebyla stisknuta žádná klávesa.
        this._mouseMoveListener = (mouseEvent: MouseEvent) => {
            this._updateModifiers(mouseEvent);
            this._eventsController.removeListener(document, "mousemove", this._mouseMoveListener);
        };

        this._eventsController.addListener(document, "mousemove", this._mouseMoveListener);
    }

    private _updateModifiers(event: KeyboardEvent | MouseEvent): void {
        let modifiersChanged = false;
        if (this._modifiers.alt !== event.altKey) {
            this._modifiers.alt = event.altKey;
            modifiersChanged = true;
            this.altChanged.trigger(this, this._modifiers.alt);
        }
        if (this._modifiers.ctrl !== event.ctrlKey) {
            this._modifiers.ctrl = event.ctrlKey;
            modifiersChanged = true;
            this.ctrlChanged.trigger(this, this._modifiers.ctrl);
        }
        if (this._modifiers.shift !== event.shiftKey) {
            this._modifiers.shift = event.shiftKey;
            modifiersChanged = true;
            this.shiftChanged.trigger(this, this._modifiers.shift);
        }

        if (modifiersChanged) {
            this.modifiersChanged.trigger(this, this._modifiers);
        }
    }

    public get alt(): boolean {
        return this._modifiers.alt;
    }

    public get ctrl(): boolean {
        return this._modifiers.ctrl;
    }

    public get shift(): boolean {
        return this._modifiers.shift;
    }

    public dispose(): void {
        this._eventsController.removeAllListeners();
    }
}
